export default __webpack_public_path__ + "static/pt-f90162e4bf935544bd3eb64647a94b0f.svg";